import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { UrlProviderService, EndPoints } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class PartyRelationshipsService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    indexPartyRelationshipStatusTypes(): Observable<any> {
        return this.get<any>(EndPoints.partyRelationships_IndexPartyRelationshipStatusTypes, undefined, undefined, undefined);
    }
}
